import React from "react";
import Arrow from "../../../assets/images/back-arrow.svg";
import "./BackButton.css";

const BackButton = (props) => {
  return (
    <div className="back-button-container">
      <div className="back-button" onClick={props.handleBackButtonClick}>
        <img
          className="back-button-img"
          src={Arrow}
          alt="Arrow pointed to the left which means go back"
        />
        <span className="back-button-text body-text">{props.btnText}</span>
      </div>
    </div>
  );
};

export default BackButton;
